import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TransportationPriceService', TransportationPriceService);

  TransportationPriceService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function TransportationPriceService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'transportations';

    var service = {
      searchTransportationPrices: searchTransportationPrices,
      saveTransportationPrices: saveTransportationPrices,
      searchTransportationPickupPrices: searchTransportationPickupPrices,
      saveTransportationPickupPrices: saveTransportationPickupPrices,
    };

    return service;

    ////////////////

    function searchTransportationPrices(transportation, filterCriteria) {
      var url = apiUrl + '/' + transportation.id + '/transportation_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = transportation.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTransportationPrices(transportation, params, editMode) {
      var url = apiUrl + '/' + transportation.id + '/transportation_prices';

      params.company_id = transportation.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PRICES_ADDED' : 'UPDATED_PRICES';
        utils._successMsg($translate(msg));

        return response.data;
      }

      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }

    function searchTransportationPickupPrices(transportation, filterCriteria) {
      var url = apiUrl + '/' + transportation.id + '/transportation_pickup_prices';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = transportation.id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTransportationPickupPrices(transportation, params, editMode) {
      var url = apiUrl + '/' + transportation.id + '/transportation_pickup_prices';

      params.company_id = transportation.id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'PICKUP_PRICES_ADDED' : 'PICKUP_COSTS_UPDATED';
        utils._successMsg($translate(msg));

        return response.data;
      }

      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
